module.exports = __webpack_public_path__ + "img/27.23591adb.jpg";